var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15_2771)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.025 6.95C13.6681 6.95 15 5.61805 15 3.975C15 2.33195 13.6681 1 12.025 1C10.382 1 9.05005 2.33195 9.05005 3.975C9.05005 5.61805 10.382 6.95 12.025 6.95Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.975 6.95C5.61805 6.95 6.95 5.61805 6.95 3.975C6.95 2.33195 5.61805 1 3.975 1C2.33195 1 1 2.33195 1 3.975C1 5.61805 2.33195 6.95 3.975 6.95Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.025 15C13.6681 15 15 13.6681 15 12.025C15 10.382 13.6681 9.05 12.025 9.05C10.382 9.05 9.05005 10.382 9.05005 12.025C9.05005 13.6681 10.382 15 12.025 15Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.975 15C5.61805 15 6.95 13.6681 6.95 12.025C6.95 10.382 5.61805 9.05 3.975 9.05C2.33195 9.05 1 10.382 1 12.025C1 13.6681 2.33195 15 3.975 15Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15_2771"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.d94a3d6081fbf8fccca3c61260e727a4.svg";
export { ForwardRef as ReactComponent };